import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

// 生产经营能力
var swiper1 = new Swiper(".section1 .show-cont .mySwiper", {
  allowTouchMove: false,
  effect: 'fade',
  speed: 500,
  autoplay: {
    delay: 3000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  breakpoints: {
    1025: {
      autoplay: false
    }
  },
  on:{
    init: function(swiper){
      $('.section1 .show-cont ul li').eq(this.realIndex).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.section1 .show-cont ul li').eq(this.realIndex).addClass('active').siblings().removeClass('active')
    },
  }
})

$('.section1 .show-cont ul li').hover(function(){
  let index = $(this).index()
  swiper1.slideTo(index)
})

$('.section1 .show-cont ul li').on('click',function(){
  let index = $(this).index()
  $('.hide-cont .item').eq(index).fadeIn(300)
  $('body').css({
    'height':'100vh',
    'overflow-y':'hidden'
  })
})
$('.hide-cont .item .close-btn').on('click',function(){
  $(this).closest('.item').fadeOut(300)
  $('body').css({
    'height':'auto',
    'overflow-y':'auto'
  })
})

$('.hide-cont .item .cont').scroll(function () {
  let scroH = $(this).scrollTop(); //滚动高度
  console.log(scroH)
  if(50 - scroH <= 20){
    $(this).siblings('.close-btn').css('top','20px')
  }else{
    $(this).siblings('.close-btn').css('top',(50 - scroH) + 'px')
  }
  
});

// 资质认证
var swiper2 = new Swiper(".section2 .contSwiper", {
  allowTouchMove: false,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  speed: 500,
  on:{
    init: function(swiper){
      $('.section2 .swiper-tab>div').eq(this.realIndex).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.section2 .swiper-tab>div').eq(this.realIndex).addClass('active').siblings().removeClass('active')
    },
  }
})
$('.section2 .swiper-tab>div').hover(function(){
  let index = $(this).index()
  swiper2.slideTo(index)
})

let swipers = $('.section2 .mySwiper');
for(let i = 0; i < swipers.length; i++){
    new Swiper(swipers[i], {
      speed: 500,
      slidesPerView: 1,
      spaceBetween: 30,
      slidesPerGroup: 1,
      breakpoints: { //响应式
        768: {  //当屏幕宽度大于等于768 
          slidesPerView: 2,
          spaceBetween: 50,
          slidesPerGroup: 2
        },
        1024: {  //当屏幕宽度大于等于768 
          slidesPerView: 3,
          spaceBetween: 50,
          slidesPerGroup: 3
        },
        1280: {  //当屏幕宽度大于等于1280
          slidesPerView: 3,
          spaceBetween: 80,
          slidesPerGroup: 3
        },
        1600: {  //当屏幕宽度大于等于1280
          slidesPerView: 3,
          spaceBetween: 145,
          slidesPerGroup: 3
        }
      },
      watchOverflow: true,
      navigation: {//按钮
        nextEl: $(swipers[i]).find('.swiper-button-next')[0],
        prevEl: $(swipers[i]).find('.swiper-button-prev')[0],
      },
    });
}


// 企业荣誉
$('.section3 .more .common-more').on('click',function(){
  $('.section3 ul li').show()
  $('.section3 .more').hide()
})
